import styled from 'styled-components'

export const SmallPrint = styled.p`
  font-size: 0.8rem;
  color: ${props => props.theme.colors.greyLight};
`
